import loggingDevInfo from '@/services/log-dev-info';
let intersectionObserver = null;
export default {
	methods: {
		addObserverHeader() {
			try {
				const qiaHeader = document.querySelector('wca-header');
				const qiaHeaderBanner = qiaHeader?.querySelector('wca-header-banner');
				function getBannerHeight() {
					return Number(qiaHeaderBanner?.getBoundingClientRect().height || 0);
				}
				if (getBannerHeight()) {
					qiaHeaderBanner?.querySelector('.header-banner__close')
						.addEventListener('click', () => {
							const wrapper = $('.wrapper');
							const wrapperHead = $('.wrapper-header');
							wrapper.css('top', 0);
							wrapperHead.css('top', 0);
						});
				}
				intersectionObserver = new IntersectionObserver((entries, observer) => {
					entries.forEach((entry) => {
						const wrapper = $('.wrapper');
						const wrapperHead = $('.wrapper-header');
						if (entry.isIntersecting) {
							const bannerHeight = getBannerHeight();
							wrapper.css('top', bannerHeight);
							wrapperHead.css('top', bannerHeight);
						} else {
							wrapper.css('top', 0);
							wrapperHead.css('top', 0);
						}
					});
				});
				if (Number(qiaHeader?.getBoundingClientRect().height || 0)) {
					intersectionObserver.observe(qiaHeaderBanner);
				}
			} catch (error) {
				console.log(error)
				loggingDevInfo(error);
			}
		},
		removeObserverHeader() {
			if (intersectionObserver?.disconnect) intersectionObserver.disconnect();
		},
	}
};
